import React from "react";

const Pricing = ({ theme }) => {
  const accentBg = theme === "dark" ? "bg-[#1c1f2b] text-white" : "bg-gray-100 text-black";
  const cardBg = theme === "dark" ? "bg-[#1e2b3a] text-white" : "bg-white text-black";

  const plans = [
    {
      name: "Fleet AI",
      price: "$49/month",
      features: ["Live Vehicle Tracking", "AI Behavior Reports", "Dashcam Video Logs"],
      popular: true,
    },
    {
      name: "OBD Tracker",
      price: "$29/month",
      features: ["OBD Data + GPS", "Remote Diagnostics", "Maintenance Alerts"],
    },
  ];

  return (
    <section id="pricing" className={`${accentBg} w-full py-16 px-4`}>
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-semibold text-center mb-10">Pricing Plans</h2>
        <div className="grid md:grid-cols-2 gap-6">
          {plans.map((plan, idx) => (
            <div key={idx} className={`${cardBg} p-6 rounded shadow relative hover:scale-105 transition-transform`}>
              {plan.popular && <span className="absolute -top-3 right-3 bg-orange-500 text-xs px-2 py-1 rounded-full">Most Popular</span>}
              <h3 className="text-lg font-bold">{plan.name}</h3>
              <p className="text-2xl text-orange-500 my-2 font-semibold">{plan.price}</p>
              <ul className="space-y-1 text-sm">
                {plan.features.map((f, i) => <li key={i}>✔️ {f}</li>)}
              </ul>
              <button className="bg-orange-500 hover:bg-orange-600 text-white w-full mt-4 py-2 rounded transition">Choose Plan</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;